import { message } from 'antd';
import { authHeader } from '../../../../helpers/auth-header';
import { client } from '../../../../actions';
import uri from '../../constants/uri';

const getServiceCompanyEmail = async (serviceCompanyId) => {
  try {
    const response = await client.get(`${uri}/service_company_emails`, {
      headers: authHeader(),
      params: { serviceCompanyId },
    });

    if (response.data.success) {
      return response.data.emails;
    }

    throw new Error(response.data.message);
  } catch (error) {
    console.log(error, 'error');

    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      'Не удалось загрузить email-адрес управляющей компании';

    message.error(errorMessage);
  }
};

export default getServiceCompanyEmail;
